var React = require('react');

function HeartIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m14.68175 1.31775c-1.757-1.757-4.607-1.757-6.364 0-.121.121-.214.259-.318.389-.104-.13-.197-.268-.318-.389-1.757-1.757-4.607-1.757-6.364 0s-1.757 4.607 0 6.364l6.682 6.318 6.682-6.318c1.757-1.757 1.757-4.607 0-6.364z","transform":"translate(.00025 .00025)"}));
}

HeartIcon.defaultProps = {"height":"14","viewBox":"-1 -1 18 16","width":"16"};

module.exports = HeartIcon;

HeartIcon.default = HeartIcon;
